// extracted by mini-css-extract-plugin
export var info = "_0-0";